function applyThumbnailSliderEnhancements() {
  const isThumbnail = document.querySelectorAll(
    ".grid__item.product__media-wrapper slider-component.thumbnail-slider",
  )[0];
  if (isThumbnail?.getBoundingClientRect()?.height > 0) {
    document
      .querySelectorAll(".grid__item.product__media-wrapper slider-component.thumbnail-slider")
      .forEach((slider) => {
        slider.addEventListener("mouseenter", (event) => {
          event.target.querySelector(".slider-button.slider-button--prev").classList.add("show");
          event.target.querySelector(".slider-button.slider-button--next").classList.add("show");
        });
        slider.addEventListener("mouseleave", (event) => {
          event.target.querySelector(".slider-button.slider-button--prev").classList.remove("show");
          event.target.querySelector(".slider-button.slider-button--next").classList.remove("show");
        });
      });
    function matchWidths() {
      const visibleMedia = Array.from(
        document.querySelectorAll(
          ".product--thumbnail_slider .product__media-item.is-active .product-media-container .product__media.media.loaded",
        ),
      ).find((el) => el.offsetParent !== null);
      const thumbnailSliders = document.querySelectorAll(
        ".grid__item.product__media-wrapper slider-component.thumbnail-slider",
      );

      if (window.innerWidth <= 749) {
        document
          .querySelectorAll(".product--thumbnail_slider .product-media-container .product__media.media.loaded")
          .forEach((element) => {
            element.style.paddingTop = "";
          });
        return;
      }

      if (visibleMedia) {
        const img = visibleMedia.querySelector(".product__media.media.loaded > img:last-child");
        visibleMedia.style.setProperty("padding-top", `${img.clientHeight}px`);
        const height = img.clientHeight;
        if (height) {
          thumbnailSliders.forEach((slider) => {
            slider.style.width = height + "px";
          });
        }
      }
    }

    window.onload = matchWidths;
    let resizeTimeout;
    window.onresize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(matchWidths, 250);
    };
    document.querySelectorAll(".thumbnail-slider .thumbnail").forEach((thumbnail) => {
      thumbnail.addEventListener("click", function () {
        let selectTimeOut;
        clearTimeout(selectTimeOut);
        selectTimeOut = setTimeout(matchWidths, 250);
        matchWidths;
      });
    });
  }

  const processSkeleton = (image) => {
    image?.closest(".lazy-image")?.classList.add("loaded");
    const skeleton = image?.closest(".lazy-image")?.previousElementSibling;
    if (skeleton && skeleton.classList.contains("image-skeleton")) {
      skeleton.classList.add("hidden");
    }
    if (isThumbnail?.getBoundingClientRect()?.height > 0) {
      matchWidths();
    }
  };

  const lazyImages = document.querySelectorAll(".lazy-image img");
  lazyImages.forEach((image) => {
    if (image.naturalWidth > 0) {
      processSkeleton(image);
    } else {
      image.addEventListener("load", function () {
        processSkeleton(image);
      });
    }
  });
}

function applyProductMediaEnhancements() {
  const productMediaLists = document.querySelectorAll(".product__media-list");
  productMediaLists.forEach((productMediaList) => {
    const nearestQuickAddModal = productMediaList?.closest(".quick-add-modal");

    if (nearestQuickAddModal) {
      const slider = nearestQuickAddModal.querySelector(".slider");
      if (slider && !slider.classList.contains("drag-initialized")) {
        slider.classList.add("drag-initialized");

        const sliderInstance = slider.closest("slider-component");
        if (sliderInstance) {
          sliderInstance.addDragToScroll();
        }
      }
    }

    let isDragging = false;

    productMediaList?.addEventListener("mousedown", () => {
      isDragging = false;
    });

    productMediaList?.addEventListener("mousemove", () => {
      isDragging = true;
    });

    productMediaList?.addEventListener("mouseup", (event) => {
      if (!isDragging && event.button !== 2) {
        const thumbnailListItems = productMediaList
          .closest(".product__media-wrapper")
          .querySelectorAll(".thumbnail-list__item:not(.thumbnail-list_item--variant:not(:first-child)) img");
        const listItems = productMediaList
          .closest(".product__media-wrapper")
          .querySelectorAll(".thumbnail-list__item:not(.thumbnail-list_item--variant:not(:first-child))");

        let index = Array.from(listItems).findIndex(
          (item) => item.querySelector('button[aria-current="true"]') !== null,
        );

        let images;

        if (thumbnailListItems.length > 0) {
          images = Array.from(thumbnailListItems).map((img) => {
            const mediaContainer = img.closest(".thumbnail-list__item");
            const mediaType = mediaContainer?.dataset.mediaType;

            if (mediaType === "video") {
              const videoUrl = mediaContainer.dataset.videoUrl;
              return {
                src: `${videoUrl}`,
                thumb: img.src,
              };
            } else {
              return {
                src: img.src.replace(/(width=)\d+/i, "$11024"),
                thumb: img.src,
              };
            }
          });
        } else {
          index = 0;
          const mediaItems = productMediaList.querySelectorAll(".product__media-item");
          images = Array.from(mediaItems)
            .map((item) => {
              const mediaType = item.dataset.mediaType;

              if (mediaType === "video" || mediaType === "external_video") {
                const videoUrl = item.dataset.videoUrl;
                const thumb = item.querySelector(".deferred-media__poster img");
                return videoUrl ? { src: videoUrl, thumb: thumb ? thumb.src : "" } : null;
              } else {
                const img = item.querySelector(".lazy-image img");
                return img ? { src: img.src.replace(/(width=)\d+/i, "$11024"), thumb: img.src } : null;
              }
            })
            .filter(Boolean);
        }

        if (nearestQuickAddModal) return;

        window.pauseAllMedia();
        const captureClick = (e) => {
          e.stopPropagation();
          e.preventDefault();
        };
        window.addEventListener("click", captureClick, { capture: true, once: true });
        setTimeout(() => window.removeEventListener("click", captureClick, true), 100);

        const box = new Fancybox(images, {
          keyboard: {
            ArrowUp: false,
            ArrowDown: false,
            ArrowRight: false,
            ArrowLeft: false,
          },
          Thumbs: {
            type: "classic",
            autoStart: window.innerWidth <= 749,
            startIndex: index,
            Carousel: {
              breakpoints: {
                "(min-width: 750px)": {
                  axis: "y",
                },
              },
            },
          },
          startIndex: index,
          Carousel: {
            friction: 0,
            Panzoom: {
              touch: false,
              drag: false,
            },
          },
          Panzoom: {
            touch: false,
            drag: false,
          },

          dragToClose: false,
        });

        box.on("reveal", () => {
          setTimeout(() => {
            const videoThumbs = document.querySelectorAll(".f-thumbs__slide.for-video:not(.has-badge)");
            videoThumbs.forEach((thumb) => {
              const badge = document.createElement("span");
              badge.className = "thumbnail__badge";
              badge.setAttribute("aria-hidden", "true");
              badge.innerHTML = `
              <span class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-play" viewBox="0 0 10 14">
                  <path fill="currentColor" fill-rule="evenodd" d="M1.482.815A1 1 0 0 0 0 1.69v10.517a1 1 0 0 0 1.525.851L10.54 7.5a1 1 0 0 0-.043-1.728z" clip-rule="evenodd"></path>
                </svg>
              </span>
            `;

              thumb.appendChild(badge);
              thumb.classList.add("has-badge");
            });
          }, 100);
        });

        document.addEventListener("keydown", function (e) {
          const key = e.key;
          if (Fancybox.getInstance()) {
            const box = Fancybox.getInstance();
            if (
              ((key === "ArrowUp" || key === "ArrowLeft") && box?.carousel?.page === 0) ||
              ((key === "ArrowDown" || key === "ArrowRight") &&
                box?.carousel?.page === box?.carousel?.slides?.length - 1)
            ) {
              box?.carousel?.slideTo(box?.carousel?.page);
            } else if (key === "ArrowUp" || key === "ArrowLeft") {
              box?.carousel?.slidePrev();
            } else if (key === "ArrowDown" || key === "ArrowRight") {
              box?.carousel?.slideNext();
            }
          }
        });

        document.addEventListener("wheel", (event) => {
          const deltaY = event.deltaY;
          if (Fancybox.getInstance()) {
            const box = Fancybox.getInstance();
            if (deltaY > 0 && box?.carousel?.page === 0) {
              box?.carousel?.slidePrev();
            } else if (deltaY < 0 && box?.carousel?.page === box?.carousel?.slides?.length - 1) {
              box?.carousel?.slideNext();
            }
          }
        });

        document.querySelectorAll(".product__media-toggle").forEach((item) => {
          item.addEventListener(
            "click",
            function (event) {
              event.stopPropagation();
              event.preventDefault();
            },
            true,
          );
        });
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  applyThumbnailSliderEnhancements();
  applyProductMediaEnhancements();
  injectFontIntoFindation();
});
